<div class="no-results-message">
    <div class="main" trans>Shared with me.</div>
    <div class="secondary" trans>Files and folders other people have shared with you.</div>
    <mat-icon svgIcon="share-custom" class="icon"></mat-icon>
</div>